import { render, staticRenderFns } from "./PagandoCheckProcessingUx.vue?vue&type=template&id=4c758100"
import script from "./PagandoCheckProcessingUx.vue?vue&type=script&lang=js"
export * from "./PagandoCheckProcessingUx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports